import { API } from "../auth/authApi";

API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");

  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }

  return req;
});

export const getRolesApi = () => {
  return API.get("/role");
};

export const createRoleApi = (data) => {
  return API.post("/role", data);
};

export const deleteRoleApi = (id) => {
  return API.delete(`/role/${id}`);
};

export const updateRoleApi = (id, data) => {
  return API.put(`/role/${id}`, data);
};

export const assignRoleApi = (data) => {
  return API.put("/user/role", data);
};
